/* eslint-disable */
import React, { useCallback, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import BASE_URL from "../Components/auth/Baseurl";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import "swiper/css";
import "swiper/css/pagination";
import DatePicker from "react-datepicker";
import { GoogleMap, MarkerF } from "@react-google-maps/api";
import "react-datepicker/dist/react-datepicker.css";
import { Pagination } from "swiper/modules";
import Layout from "../Components/layout/Layout";
import StripeCheckout from "react-stripe-checkout";
import Swal from "sweetalert2";

const Details = () => {
  
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [get, setGet] = useState([]);
  const [getone, setGetone] = useState([]);
  const [data, setData] = useState();
  const { id } = useParams();
  const fetchData = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/listing/${id}`, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      // console.log(response.data?.listing?.lng, ">>>>>>>>>>>>>");
      setData(response.data?.listing);
      setGet(eval(JSON.parse(response.data?.listing?.facilities)));
      setGetone(eval(JSON.parse(response.data?.listing?.amenities)));
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  console.log(data, "data");

  // console.log(totalstripe,"??");
  // console.log(startDate, "values");
  // amenities and facilities api end //
  // stripe start //

  // const onToken = async (token, note) => {
  //   try {
  //     // console.log(token, "token");
  //     const formData = new FormData();
  //     // console.log(noteValue.note, "note");
  //     formData.append("token", token.id);
  //     formData.append("listing_id", data.id);
  //     formData.append("payment_method", "stripe");
  //     formData.append("no_of_guest", quantity);
  //     formData.append("note", text);
  //     formData.append("first_name", userData.first_name);
  //     formData.append("last_name", userData1.last_name);
  //     formData.append("phone", userData2.contact_phone);
  //     formData.append("total", totalAmount);

  //     // Arrival Date
  //     if (startDate) {
  //       const formattedArrivalDate = startDate.toISOString().split("T")[0];
  //       formData.append("arrive_date", formattedArrivalDate);
  //     }

  //     // Departure Date
  //     if (endDate) {
  //       const formattedDepartureDate = endDate.toISOString().split("T")[0];
  //       formData.append("depart_date", formattedDepartureDate);
  //     }

  //     const response = await axios.post(`${BASE_URL}/booking`, formData, {
  //       headers: {
  //         "Content-Type": "multipart/form-data",
  //         Authorization: `Bearer ${localStorage.getItem("token")}`,
  //       },
  //     });

  //     // console.log("Booking successful!", response.data);
  //     Swal.fire({
  //       position: "top-end",
  //       icon: "success",
  //       title: "Booking successfully",
  //       showConfirmButton: false,
  //       timer: 1500,
  //     });
  //   } catch (error) {
  //     console.error("Error submitting booking:", error);
  //     Swal.fire({
  //       icon: "error",
  //       title: "Oops...",
  //       text: "Error submitting booking:",
  //     });
  //   }
  // };

  // stripe total amount calculate

  // const rates = {
  //   nightly: data?.nightly,
  //   weekend: data?.weekend,
  //   weekly_seven_plus: data?.weekly_seven_plus,
  //   weekly_thirty_plus: data?.weekly_thirty_plus,
  // };

  // Define the function to calculate total amount
  // function calculateTotalAmount(startDate, endDate, rates) {
  //   // Convert Dates to JavaScript Date Objects
  //   const arrivalDate = new Date(startDate);
  //   const departureDate = new Date(endDate);

  //   // Calculate the total number of days between Arrival and Departure
  //   const totalDays = Math.ceil((departureDate - arrivalDate) / (1000 * 60 * 60 * 24));

  //   // Initialize counts for weekdays, weekends, and months
  //   let weekdayCount = 0;
  //   let weekendCount = 0;
  //   let monthCount = 0;

  //   // Loop through each day to count weekdays, weekends, and months
  //   for (let i = 0; i < totalDays; i++) {
  //       const currentDate = new Date(arrivalDate);
  //       currentDate.setDate(arrivalDate.getDate() + i);
  //       const currentDay = currentDate.getDay(); // Sunday: 0, Monday: 1, ..., Saturday: 6

  //       // Check if it's a weekday (Monday to Friday)
  //       if (currentDay >= 1 && currentDay <= 5) {
  //           weekdayCount++;
  //       } else if (currentDay === 0 || currentDay === 6) { // Check if it's a weekend (Saturday or Sunday)
  //           weekendCount++;
  //       }

  //       // Check if it's a new month
  //       if (currentDate.getDate() === 1) {
  //           monthCount++;
  //       }
  //   }

  //   // Initialize total amount
  //   let totalAmount = 0;

  //   // Calculate total amount based on rates
  //   if (totalDays <= 7) {
  //       // If total days are less than or equal to 7 (1 week or less)
  //       totalAmount = weekdayCount * rates.nightly + weekendCount * rates.weekend + monthCount * rates.weekly_seven_plus;
  //   } else if (totalDays <= 30) {
  //       // If total days are less than or equal to 30 (1 month or less)
  //       totalAmount = weekdayCount * rates.nightly + weekendCount * rates.weekend + monthCount * rates.weekly_thirty_plus;
  //   } else {
  //       // If total days are more than 30 (more than 1 month)
  //       const weeks = Math.floor(totalDays / 7);
  //       const remainingDays = totalDays % 7;
  //       totalAmount = (weeks * (weekdayCount * rates.nightly + 2 * weekendCount * rates.weekend + monthCount * rates.weekly_thirty_plus)) + (remainingDays * rates.nightly);

  //   }
  //   totalAmount += rates.city_fee + rates.clean_fee + rates.security_deposit + rates.tax;
  //   // Return the total amount
  //   return totalAmount;
  // }

  // Assuming rates are dynamic strings

  // Call calculateTotalAmount function with startDate, endDate, and rates
  // const totalAmount = calculateTotalAmount(startDate, endDate, rates);

  // console.log(totalAmount, "valuetotal");

  // end  stripe total amount  calculate

  const [quantity, setQuantity] = useState(1);

  const handleIncrement = () => {
    setQuantity(quantity + 1);
  };

  const handleDecrement = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };
  // console.log(quantity, "valueGet");

  const [userData, setUserData] = useState({});
  const [userData1, setUserData1] = useState({});
  const [userData2, setUserData2] = useState({});

  useEffect(() => {
    const retrievedData = JSON.parse(localStorage.getItem("data"));
    // console.log(retrievedData, "name");
    if (retrievedData) {
      setUserData(retrievedData);
    }
    if (retrievedData) {
      setUserData1(retrievedData);
    }
    if (retrievedData) {
      setUserData2(retrievedData);
    }
  }, []);
  const [text, setText] = useState("");
  const handleValue = (e) => {
    const value = e.target.value;
    setText(value);
  };

  const defaultCenter = { lat: 0, lng: 0 };
  const center = {
    lat: Number(data?.lat) || defaultCenter.lat,
    lng: Number(data?.lng) || defaultCenter.lng,
  };

  // console.log(center.lat, "lat");
  return (
    <Layout>
      <div id="wrapper">
        <div className="content">
          <section
            className="listing-hero-section hidden-section"
            data-scrollax-parent="true"
            id="sec1"
          >
            {data?.listing_images?.[0] && (
              <div className="bg-parallax-wrap">
                <div
                  className="bg par-elem "
                  // data-bg="images/bg/6.jpg"
                  data-scrollax="properties: { translateY: '30%' }"
                  style={{
                    backgroundImage: `url(${data.listing_images[0]?.image})`,
                    transform: "translateZ(0px) translateY(-3.24763%)",
                  }}
                />
                <div className="overlay" />
              </div>
            )}

            <div className="container">
              <div className="list-single-header-item  fl-wrap">
                <div className="row">
                  <div className="col-md-9">
                    <h1>
                      {data?.title}
                      <span className="verified-badge">
                        <i className="fal fa-check" />
                      </span>
                    </h1>
                    <div className="geodir-category-location fl-wrap">
                      <Link to="#">
                        <i className="fas fa-map-marker-alt" /> {data?.area}
                      </Link>{" "}
                      <Link to="#">
                        <i className="fal fa-envelope" /> {data?.host?.email}
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="list-single-header_bottom fl-wrap">
                <div className="list-single-author">
                  {" "}
                  <Link to="author-single.html">
                    <span className="author_avatar">
                      {" "}
                      <img alt="" src={data?.host?.image} />
                    </span>
                    {data?.host?.first_name}
                  </Link>
                </div>
              </div>
            </div>
          </section>
          {/* scroll-nav-wrapper*/}
          
        
          <section className="gray-bg no-top-padding">
            <div className="container">
            
              <div className="clearfix" />
              <div className="row">
                <div className="col-md-8">
                  <div className="list-single-main-wrapper fl-wrap" id="sec2">
                    <div className="list-single-main-item fl-wrap block_box">
                      <div className="list-single-main-item-title">
                        <h3>Description</h3>
                      </div>
                      <div className="list-single-main-item_content fl-wrap">
                        <p>{data?.description}</p>
                      </div>
                    </div>
                    {/* list-single-main-item end */}
                    {/* list-single-main-item */}
                    <div className="list-single-main-item fl-wrap block_box">
                      <div className="list-single-main-item-title">
                        <h3>Amenities</h3>
                      </div>
                      <div className="list-single-main-item_content fl-wrap">
                        <div className="listing-features fl-wrap">
                          <ul className="no-list-style">
                            {Array.isArray(getone) &&
                              getone.map((amenity, index) => (
                                <li key={index}>
                                  <Link to="#">
                                    <i className="fa fa-rocket" /> {amenity}
                                    Text
                                  </Link>
                                </li>
                              ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="list-single-main-item fl-wrap block_box">
                      <div className="list-single-main-item-title">
                        <h3>Facilities</h3>
                      </div>
                      <div className="list-single-main-item_content fl-wrap">
                        <div className="listing-features fl-wrap">
                          <ul className="no-list-style">
                            {Array.isArray(get) &&
                              get.map((amenity, index) => (
                                <li key={index}>
                                  <Link to="#">
                                    <i className="fa fa-rocket" /> {amenity}
                                    Text
                                  </Link>
                                </li>
                              ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                    {/* list-single-main-item end */}
                    {/* list-single-main-item*/}
                    <div
                      className="list-single-main-item fl-wrap block_box"
                      id="sec3"
                    >
                      <div className="list-single-main-item-title">
                        <h3>Gallery / Photos</h3>
                      </div>
                      <div className="list-single-main-item_content fl-wrap">
                        <div className="single-carousel-wrap fl-wrap lightgallery">
                          <div
                            className="sc-next sc-btn color2-bg"
                            tabIndex={0}
                            role="button"
                            aria-label="Next slide"
                            aria-disabled="false"
                          >
                            <i className="fas fa-caret-right" />
                          </div>
                          <div
                            className="sc-prev sc-btn color2-bg swiper-button-disabled"
                            tabIndex={0}
                            role="button"
                            aria-label="Previous slide"
                            aria-disabled="true"
                          >
                            <i className="fas fa-caret-left" />
                          </div>
                          <div className="single-carousel fl-wrap full-height">
                            <div
                              className="swiper-container swiper-container-horizontal swiper-container-free-mode"
                              style={{ cursor: "grab" }}
                            >
                              {/* swiper-slide*/}
                              <Swiper
                                slidesPerView={3}
                                spaceBetween={20}
                                pagination={{
                                  clickable: true,
                                }}
                                modules={[Pagination]}
                                className="mySwiper"
                              >
                                {data?.listing_images.map((slide) => (
                                  <SwiperSlide key={slide.id}>
                                    <div
                                      className="swiper-slide"
                                      // style={{ marginRight: 10 }}
                                    >
                                      <div className="box-item">
                                        <img src={slide.image} alt="" />{" "}
                                        {/* Assuming the image URL is in slide.image */}
                                        <Link
                                          to={slide.link}
                                          className="gal-link popup-image"
                                        >
                                          <i className="fa fa-search" />
                                        </Link>
                                      </div>
                                    </div>
                                  </SwiperSlide>
                                ))}
                              </Swiper>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                 
                    {/* list-single-main-item end */}
                  </div>
                </div>
                {/* list-single-main-wrapper-col end */}
                {/* list-single-sidebar */}
                <div className="col-md-4">
                  {/*box-widget-item */}
                  <div className="box-widget-item fl-wrap block_box">
                    <div className="box-widget-item-header">
                      <h3>Working Hours</h3>
                    </div>
                    <div className="box-widget opening-hours fl-wrap">
                      <div className="box-widget-content">
                        <ul className="no-list-style">
                          <li className="mon">
                            <span className="opening-hours-day">
                              Check in Aftar{" "}
                            </span>
                            <span className="opening-hours-time">
                              {data?.check_in_after}
                            </span>
                          </li>
                          <li className="tue">
                            <span className="opening-hours-day">
                              Check in Before{" "}
                            </span>
                            <span className="opening-hours-time">
                              {data?.check_in_before}
                            </span>
                          </li>
                          <li className="wed todaysDay">
                            <span className="opening-hours-day">
                              Apply Weekend Price{" "}
                            </span>
                            <span className="opening-hours-time">
                              {data?.apply_weekend_price}
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  {/* // stripe booking start // */}
                  {/* <div className="box-widget-item fl-wrap block_box">
                    <div className="box-widget-item-header">
                      <h3>Book a Table</h3>
                    </div>
                    <div className="box-widget">
                      <div className="box-widget-content">
                        <Formik
                          initialValues={{
                            arrive_date: null,
                            depart_date: null,
                            note: "",
                          }}
                          validationSchema={Yup.object().shape({
                            arrive_date: Yup.date().required("Required"),
                            depart_date: Yup.date()
                              .min(
                                Yup.ref("arrive_date"),
                                "Departure date must be after arrival date"
                              )
                              .required("Required"),
                            note: Yup.string(),
                          })}
                        >
                          {({ isSubmitting }) => (
                            <Form className="add-comment custom-form">
                              <fieldset>
                                <div className="date-picker-container d-flex">
                                  <p className="opening-hours-day">
                                    {" "}
                                    Arrival Date
                                  </p>
                                  <DatePicker
                                    selected={startDate}
                                    onChange={(date) => {
                                      setStartDate(date);
                                      setEndDate(null);
                                    }}
                                    placeholderText="Arrival Date"
                                  />
                                  <p className="opening-hours-day">
                                    Departure Date
                                  </p>
                                  <DatePicker
                                    selected={endDate}
                                    onChange={(date) => setEndDate(date)}
                                    placeholderText="Departure Date"
                                    minDate={startDate}
                                  />
                                </div>
                                <div className="quantity fl-wrap">
                                  <span>
                                    <i className="fal fa-user-plus"></i>Guest :{" "}
                                  </span>
                                  <div className="quantity-item">
                                    <input
                                      type="button"
                                      value="-"
                                      className="minus"
                                      onClick={handleDecrement}
                                    />
                                    <input
                                      type="text"
                                      name="quantity"
                                      title="Qty"
                                      className="qty color-bg"
                                      data-min="1"
                                      data-max="3"
                                      data-step="1"
                                      value={quantity}
                                    />
                                    <input
                                      type="button"
                                      onClick={handleIncrement}
                                      value="+"
                                      className="plus"
                                    />
                                  </div>
                                </div>
                                <div className="dashboard-title dt-inbox fl-wrap">
                                  <h3>Extra Services</h3>
                                </div>
                                <div className="custom-form">
                                  <ul className="fl-wrap filter-tags no-list-style ds-tg">
                                    {data?.listing_extra_service_prices?.map(
                                      (service, index) => (
                                        <li key={index}>
                                          <input
                                            id={service.id}
                                            type="checkbox"
                                            name={service.name}
                                            defaultChecked=""
                                            value={service.name}
                                          />
                                          <label htmlFor={service.id}>
                                            {service.name}
                                          </label>
                                          <label
                                            style={{
                                              textAlign: "end",
                                              display: "flex",
                                              width: "150px",
                                              justifyContent: "end",
                                            }}
                                            htmlFor={service.id}
                                          >
                                            {service.price}
                                          </label>
                                        </li>
                                      )
                                    )}
                                  </ul>
                                </div>
                                <textarea
                                  as="textarea"
                                  name="note"
                                  cols="40"
                                  onChange={handleValue}
                                  rows="3"
                                  placeholder="Additional Information:"
                                />
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                  className="box-widget-item-header"
                                >
                                  <h3>Total</h3>
                                  <p>{totalAmount}</p>
                                </div>
                                <StripeCheckout
                                  token={(token) => onToken(token)}
                                  stripeKey="pk_test_51OM5QgHIC6YSoZmKJYiuVcSsPM6QHO7iVNjQi5t0mSudvWzgSdos55tgQyTOmaFrEqdzHYBYpf7SB6aMGahsfVkn00xlfczKqR"
                                >
                                  <button
                                    type="submit"
                                    className="btn color2-bg url_btn float-btn"
                                    disabled={isSubmitting}
                                  >
                                    {isSubmitting
                                      ? "Submitting..."
                                      : "Book Table Now"}
                                    <i className="fal fa-bookmark" />
                                  </button>
                                </StripeCheckout>
                              </fieldset>
                            </Form>
                          )}
                        </Formik>
                      </div>
                    </div>
                  </div> */}
                  {/* // stripe booking end  // */}



                  <div className="box-widget-item fl-wrap block_box">
                    <div className="box-widget-item-header">
                      <h3>Location</h3>
                    </div>
                    <div className="box-widget">
                      <div className="map-container">
                        <div>
                          <div style={{ height: "300px", width: "100%" }}>
                            {data?.lat && data?.lng && (
                              <GoogleMap
                                mapContainerStyle={{
                                  height: "300px",
                                  // width: "100%",
                                }}
                                center={center}
                                zoom={10}
                                apiKey="AIzaSyDXJS_VZMhnp0szh92aZGg8RHszz6RMQN8"
                              >
                                <MarkerF position={center} />
                              </GoogleMap>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="box-widget-content bwc-nopad">
                        <div className="list-author-widget-contacts list-item-widget-contacts bwc-padside">
                          <ul className="no-list-style">
                            <li>
                              <span>
                                <i className="fal fa-map-marker" /> Adress :
                              </span>{" "}
                              <Link to="#">{data?.address}</Link>
                            </li>
                          </ul>
                        </div>
                        <div className="list-widget-social bottom-bcw-box  fl-wrap">
                          <ul className="no-list-style">
                            <li>
                              <Link to="#">
                                <i className="fab fa-facebook-f" />
                              </Link>
                            </li>
                            <li>
                              <Link to="#">
                                <i className="fab fa-twitter" />
                              </Link>
                            </li>
                            <li>
                              <Link to="#">
                                <i className="fab fa-vk" />
                              </Link>
                            </li>
                            <li>
                              <Link to="#">
                                <i className="fab fa-instagram" />
                              </Link>
                            </li>
                          </ul>
                          <div className="bottom-bcw-box_link">
                            <Link
                              to="#"
                              className="show-single-contactform tolt"
                              data-microtip-position="top"
                              data-tooltip="Write Message"
                            >
                              <i className="fal fa-envelope" />
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="box-widget-item fl-wrap block_box">
                    <div className="box-widget-item-header">
                      <h3> Price Range </h3>
                    </div>
                    <div className="box-widget">
                      <div className="box-widget-content">
                        <div className="claim-price-wdget fl-wrap">
                          <div className="claim-price-wdget-content fl-wrap">
                            <div className="pricerange fl-wrap">
                              <span>Additional Guest Price : </span>
                              {data?.addi_guest_price}
                            </div>
                            <div className="pricerange fl-wrap">
                              <span>City Fee : </span>
                              {data?.city_fee}
                            </div>
                            <div className="pricerange fl-wrap">
                              <span>City Fee Daily: </span>
                              {data?.city_fee_daily}
                            </div>
                            <div className="pricerange fl-wrap">
                              <span>City Fee Per stay: </span>
                              {data?.city_fee_per_stay}
                            </div>
                            <div className="pricerange fl-wrap">
                              <span>Clean Fee: </span>
                              {data?.clean_fee}
                            </div>
                            <div className="pricerange fl-wrap">
                              <span>Clean Fee Daily: </span>
                              {data?.clean_fee_daily}
                            </div>
                            <div className="pricerange fl-wrap">
                              <span>Clean Fee Per stay: </span>
                              {data?.clean_fee_per_stay}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div className="limit-box fl-wrap" />
        </div>
      </div>
    </Layout>
  );
};

export default Details;
